import TextIcon from "./TextIcon.component.jsx";

export default TextIcon;